import { Dispatch } from 'redux';
import DataQualityTestController from '../controllers/DataQualityTestController';
import commonHandler from '../errorHandlers/common-handler';
import { DataQualityTestConfigurationPayload } from '../model/DataQualityTestModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class DataQualityTestCRUDActions extends CrudActionContainer {
  retrievedResultAction: string;
  resetStore: string;

  constructor() {
    super('DATA_QUALITY_TEST');
    this.retrievedResultAction = super.makeActionKey('RETRIEVED_RESULT');
  }

  getConfiguration(facebookPageId?: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        const response = await DataQualityTestController.getConfiguration(
          facebookPageId,
        );

        dispatch(this.retrievedAll(response));
        return response;
      } catch (error) {
        await commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  createConfiguration(config: DataQualityTestConfigurationPayload) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));
      try {
        const response = await DataQualityTestController.createConfiguration(
          config,
        );
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  updateConfiguration(config: DataQualityTestConfigurationPayload) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));

      try {
        const response = await DataQualityTestController.updateConfiguration(
          config,
        );
        dispatch(this.retrievedAll(response));
        return response;
      } catch (error) {
        commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  getResult(facebookPageId?: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const response = await DataQualityTestController.getResult(
          facebookPageId,
        );
        dispatch({ type: this.retrievedResultAction, results: response });
        return response;
      } catch (error) {
        await commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }
}

const dataQualityTestCRUDActions = new DataQualityTestCRUDActions();

export default dataQualityTestCRUDActions;

export const useDataQualityTestCRUDActions = getActionHookBuilder(
  dataQualityTestCRUDActions,
  [
    'createConfiguration',
    'getConfiguration',
    'updateConfiguration',
    'getResult',
  ],
);
